import comp from "./ModalComponent";
export default comp;
